<template>
  <section>
    <div class="container-fluid forms mb-5">
      <div class="row">
        <div
          class="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 align-self-center  mb-0"
        >
          <b-form-group class="mb-0">
            <b-input-group size="sm" class="input-search">
              <b-input-group-prepend class="pt-1 pl-1">
                <i class="flaticon-bold-magnifier"></i>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model.trim="simpleSearch"
                v-on:input="applySimpleSearch"
                type="search"
                placeholder="Search Anything..."
                class="border-none"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </div>
        <div
          class="col-xl-8 col-lg-8 col-md-6 col-sm-6 col-12 text-right align-self-center mb-4"
        >
          <div class="box-buttons ">
            <base-button
              v-if="canUserDelete && selectedRows.length > 0"
              type="outline-neutral"
              class="min-button btn-line-danger"
              @click="deleteMany(selectedRows)"
            >
              <i class="flaticon-delete"></i>Delete
            </base-button>

            <base-button
              v-if="canUserCreate"
              type="primary"
              @click="goToNewAgent(partnerId, approve)"
              class="min-button mb-0"
            >
              <i class="flaticon-plus"></i> New Agent
            </base-button>
          </div>
        </div>
      </div>

      <div class="row mb-1">
        <div
          class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 align-self-center mb-lg-0 mb-3 text-right"
        >
          <div class="col-xl-7 col-lg-7 col-md-7 ml-auto d-inline-block">
            <b-form-group
              label="Sort"
              label-for="sort-by-select"
              label-cols-sm="2"
              label-align-sm="right"
              label-size="sm"
              v-slot="{ ariaDescribedby }"
              class="mb-0"
              size="sm"
            >
              <b-input-group>
                <b-form-select
                  id="sort-by-select"
                  v-model="sortBy"
                  :options="sortOptions"
                  :aria-describedby="ariaDescribedby"
                  @change="applySortBy"
                  class="w-70"
                  size="sm"
                >
                  <template #first>
                    <option value="">-- None --</option>
                  </template>
                </b-form-select>

                <b-form-select
                  v-model="sortDesc"
                  :disabled="!sortBy"
                  @change="applySortType"
                  :aria-describedby="ariaDescribedby"
                  class="w-30"
                  size="sm"
                >
                  <option :value="'asc'">Asc</option>
                  <option :value="'desc'">Desc</option>
                </b-form-select>
              </b-input-group>
            </b-form-group>
          </div>
          <div class="d-inline-block mr-2">
            <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
              <b-form-radio-group
                id="btn-radios-view"
                v-model="view"
                :aria-describedby="ariaDescribedbyview"
                name="radios-btn-default"
                buttons
                @change="changeViewCard"
                class="mb-0"
                button-variant="outline-neutral pc-3"
              >
                <b-form-radio value="table"
                  ><i class="flaticon-two" title="View Table"></i
                ></b-form-radio>
                <b-form-radio value="card"
                  ><i class="flaticon-menu" title="View Card"></i
                ></b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div class="d-inline-block">
            <el-tooltip content="Export" placement="bottom">
              <base-dropdown
                menu-on-right
                class="nav-item"
                tag="div"
                title-tag="a"
                title-classes="btn btn-outline-neutral btn-icon-only m-0 dropnocaret"
                title="Export"
              >
                <base-button
                  slot="title"
                  type="none"
                  class="pl-0 pr-0 icon-only"
                >
                  <i class="flaticon-downloading-files mr-0 "></i>
                </base-button>

                <div
                  class="dropdown-item"
                  @click="download(selectedRows)"
                  v-if="selectedRows.length > 0"
                >
                  Selected Records
                </div>
                <div class="dropdown-item" @click="download([])">
                  All Records
                </div>
              </base-dropdown>
            </el-tooltip>
          </div>
        </div>
      </div>

      <div>
        <pagination-block
          :pageCount="agents.pages"
          :total="agents.count"
          v-model="currentPage"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>

        <b-table
          hover
          :items="agents.docs"
          :fields="fields"
          sort-by.sync="created_at"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length == agents.docs.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(name)="data">
            <router-link
              :to="`/partners/${data.item._id}`"
              class="link-img-profile"
            >
              <div
                v-if="data.item.url_picture"
                class="img-user-list"
                v-bind:style="{
                  backgroundImage: `url('${data.item.url_picture}')`
                }"
              ></div>

              <div
                v-else
                class="img-user-list"
                v-bind:style="{
                  backgroundImage: 'url(' + imageProfile + ')'
                }"
              ></div>

              <div class="content">
                <span class="username hide-data">
                  {{ data.item.first_name }}
                  {{ data.item.last_name }}</span
                >
              </div>
            </router-link>
          </template>

          <template #cell(email)="data">
            <a
              class="hide-data"
              :href="`mailto:${data.item.email}`"
              target="_blank"
              >{{ data.item.email }}</a
            >
          </template>
          <template #cell(role)="data">
            <span class="text-capitalize">{{
              data.item.type | typeOperator
            }}</span>
          </template>
          <template #cell(markup)="data">
            <span>{{ data.item.mark_up }}%</span>
          </template>
          <template #cell(commercialTerms)="data">
            <span class="role-table">{{
              getCommercialTerms(data.item.type_charge)
            }}</span>
            <span>{{ data.item.commission }}%</span>
          </template>
          <template #cell(status)="data">
            <div
              class="badge-status badge-success"
              v-if="data.item.status == true"
            >
              <span>Active</span>
            </div>

            <div class="badge-status badge-danger" v-else>
              <span>Inactive</span>
            </div>
          </template>

          <template #cell(actions)="data">
            <el-tooltip v-if="canUserUpdate" content="Edit" placement="bottom">
              <router-link
                class="icon-action text-blue"
                :to="`/partners/${data.item._id}?mode=edit`"
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                v-if="canUserDelete"
                class="icon-action text-danger ml-2"
                @click.stop="deleteAgents(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>

            <el-tooltip
              v-if="canUserUpdate"
              content="Change Status"
              placement="bottom"
            >
              <span
                class="icon-action ml-2"
                @click.stop="changeStatus(data.item._id, !data.item.status)"
              >
                <i class="flaticon-right-4"></i>
              </span>
            </el-tooltip>
          </template>
        </b-table>
        <pagination-block
          :pageCount="agents.pages"
          :total="agents.count"
          :limit="limit"
          @changeLimit="changeLimit"
          v-model="currentPage"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapMutations, mapGetters, mapActions } from "vuex";
import { PartnersAPI } from "../../../core/api";
import Swal from "sweetalert2";
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
import lodash from "lodash";
import { isUserAuthorized, setSigOut } from "../../../helpers/commons.helpers";
export default {
  name: "AgentList",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu
  },
  props: {
    partnerId: {
      type: String,
      require: true
    },
    approve: {
      type: Boolean,
      require: true
    }
  },
  data() {
    return {
      currentPage: 1,
      selectedRows: [],
      limit: 0,
      searchQuery: "",
      query: "",
      searchStatus: "",
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "name",
          label: "Agent",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },

        {
          key: "email",
          label: "Email",
          sortable: true,
          thStyle: { minWidth: "150px" },
          class: "text-left"
        },
        {
          key: "role",
          label: "Role",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "markup",
          label: "Markup",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "commercialTerms",
          label: "Commercial Terms",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      simpleSearch: "",
      sortBy: "",
      sortDesc: "asc",
      sortDirection: "asc",
      sortOptions: [
        {
          value: "name",
          text: "Agent Name"
        },
        {
          value: "email",
          text: "Email"
        },
        { value: "created_at", text: "Created At" }
      ],
      view: "table",
      agents: {
        pages: 1,
        page: 0,
        docs: [],
        count: 0
      },
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png")
    };
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    await this.getAgents(this.partnerId, this.limit, this.currentPage, "");
  },
  methods: {
    async changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        await this.getAgents(
          this.partnerId,
          this.limit,
          this.currentPage,
          this.query
        );
      }
    },
    async previousPaginations(page) {
      await this.getAgents(this.partnerId, this.limit, page, this.query);
    },
    async nextPaginations(page) {
      await this.getAgents(this.partnerId, this.limit, page, this.query);
    },
    async changePage(page) {
      await this.getAgents(this.partnerId, this.limit, page, this.query);
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value.trim());
      } else {
        searchParams.append(key, value.trim());
      }
      return searchParams.toString();
    },
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    async applySimpleSearch(value) {
      this.query = this.addElementInQuery(this.query, "search", value);
      await this.getAgents(this.partnerId, this.limit, 1, this.query);
    },
    async typeSearch(type) {
      if (type === "all") {
        this.query = this.deleteItemInQuery(this.query, ["type"]);
        await this.getAgents(this.partnerId, this.limit, 1, this.query);
      } else {
        this.query = this.addElementInQuery(this.query, "type", type);
        await this.getAgents(this.partnerId, this.limit, 1, this.query);
      }
    },
    async applySortBy(value) {
      this.query = this.addElementInQuery(this.query, "sortBy", value);
      this.query = this.addElementInQuery(
        this.query,
        "sortType",
        this.sortDesc
      );
      await this.getAgents(
        this.partnerId,
        this.limit,
        this.currentPage,
        this.query
      );
    },
    async applySortType(value) {
      this.query = this.addElementInQuery(this.query, "sortType", value);
      await this.getAgents(
        this.partnerId,
        this.limit,
        this.currentPage,
        this.query
      );
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    async deleteAgents(agentId) {
      let { value } = await Swal.fire({
        title: "Delete Agents",
        text: "Are you sure do you want to delete this Agent?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteAgentsById(agentId);
      }
    },
    async deleteAgentsById(agentId) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.deletePartnersById(
          agentId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Agent has been Deleted",
            icon: "flaticon-check-3"
          });
          await this.getAgents(
            this.partnerId,
            this.limit,
            this.currentPage,
            this.query
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async deleteMany() {
      let { value } = await Swal.fire({
        title: "Delete Agents",
        text: "Are you sure do you want to delete the selected Agents?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyAgentsById(
          this.selectedRows.map(element => element._id)
        );
      }
    },
    async deleteManyAgentsById(partners = []) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.deleteManyPartnersById(
          { partners: partners },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Agents has been Deleted",
            icon: "flaticon-check-3"
          });
          await this.getAgents(
            this.partnerId,
            this.limit,
            this.currentPage,
            this.query
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async changeStatus(agentId, status) {
      let { value } = await Swal.fire({
        title: "Change status",
        text: `Are you sure do you want change status the selected Agent?`,
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.changeStatusByAgentId(agentId, status);
      }
    },
    async changeStatusByAgentId(agentId, status) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.changePartnerId(
          agentId,
          { status: status },
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Agents has been Updated",
            icon: "flaticon-check-3"
          });
          await this.getAgents(
            this.partnerId,
            this.limit,
            this.currentPage,
            this.query
          );
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    async download(agents = []) {
      try {
        this.setLoad(true);
        let { data } = await PartnersAPI.exportAgentsByPartnerId(
          this.partnerId,
          { agents: agents },
          this.query,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.code === 200) {
          const url = window.URL.createObjectURL(new Blob([data.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `agents-${moment().format("DD-MM-YYYY")}.csv.csv`
          );
          document.body.appendChild(link);
          link.click();
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The data was not download. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The data was not download. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = setSigOut(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    changeViewCard() {
      if (this.view === "table") {
        this.cardview = false;
      } else {
        this.cardview = true;
      }
    },
    async getAgents(partnerId, limit, page, query) {
      try {
        let { data } = await PartnersAPI.getAgentsByAgencyId(
          partnerId,
          limit,
          page,
          query,
          this.sesion.token
        );
        if (data.status) {
          this.agents = lodash.cloneDeep(data.data);
        } else {
          this.agents = {
            pages: 1,
            page: 0,
            docs: [],
            count: 0
          };
        }
      } catch (error) {
        this.agents = {
          pages: 1,
          page: 0,
          docs: [],
          count: 0
        };
      }
    },
    goToNewAgent(association, approve) {
      if (!approve) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message:
            "You must approve this partner as an agency to be able to add an agent.",
          icon: "flaticon-warning-1"
        });
      } else {
        this.$router.push({
          path: "/partners/new",
          query: { association: association, partnerType: "travel_access" }
        });
      }
    },
    getCommercialTerms(type) {
      if (type === "commission") {
        return "Commission";
      } else {
        return "Net Price";
      }
    },
    ...mapActions(["getLimit"]),
    ...mapMutations(["setLoad", "setItemsBread"])
  },
  computed: {
    ...mapGetters(["sesion", "userRole", "paginationLimit"]),
    canUserDelete() {
      return isUserAuthorized("PARTNERS", this.userRole, "DELETE");
    },
    canUserCreate() {
      return isUserAuthorized("PARTNERS", this.userRole, "CREATE");
    },
    canUserUpdate() {
      return isUserAuthorized("PARTNERS", this.userRole, "UPDATE");
    }
  },
  filters: {
    typeOperator: function(type) {
      if (type === "travel_access") {
        return "Manager Access";
      } else {
        return "Manager Access";
      }
    },
    statusOperator: function(status) {
      if (status) {
        return "Active";
      } else {
        return "Inactive";
      }
    }
  }
};
</script>
<style lang="scss"></style>
